// To use Html5QrcodeScanner (more info below)
import {Html5QrcodeScanner} from "html5-qrcode"

// To use Html5Qrcode (more info below)
import {Html5Qrcode} from "html5-qrcode";
import bootbox from "bootbox";

$(document).ready(function (e) {
    let Scanner;
    if ($('#reader').length) {
        Scanner = new Html5Qrcode("reader");
    }
    let config = {fps: 10, qrbox: {width: 250, height: 250}};
    $('#html5-qrcode-file-input').remove();
    $(document).on('click', '.get-barcode', function (e) {
        let $this = $(this);
        $('.active-barcode').removeClass('active-barcode');
        $this.addClass('active-barcode');
        $('#qr-window').modal('show');
        Scanner
            .start({facingMode: "environment"}, config, (decodedText, decodedResult) => {
                $('#qr-window').modal('hide');
                let $field = $('.active-barcode').parents('.form-group').find('.relation-data-field');
                $field.val(decodedText).trigger('keyup', ['barcode']);
                Scanner.stop().then((ignore) => {
                    $('#html5-qrcode-file-input').remove();
                }).catch((err) => {
                    // Stop failed, handle it.
                });
            })
            .then(() => {
                $('#qr-code-spinner').addClass('d-none');
            })
            .catch(function (err) {
                $('#qr-window').modal('hide');
            });
    });

    $('.init-btn-barcode').on('click', function (e) {
        e.preventDefault();
        let button_id = $(this).attr('data-id'),
            resource_id = $(this).attr('data-record-id'),
            message_with_record = parseInt($(this).attr('data-message-with-record'));

        $('#qr-window').modal('show');
        setTimeout(function (e) {
            Scanner
                .start({facingMode: "environment"}, config, (decodedText, decodedResult) => {
                    $('#qr-window').modal('hide');
                    $.ajax({
                        type: 'POST',
                        url: '/tables/button/barcode/execute',
                        data: {
                            button_id,
                            resource_id,
                            search: decodedText
                        },
                        success: function (res) {
                            let $section = $(`.tbl-section.mobile[data-section-id="${res.section}"]`);
                            if (res.record) {
                                let $record = $section.find(`.mobile-rows[data-id="${res.record}"]`),
                                    url = $record.parents('a').attr('href');

                                url = url + '&barcode_btn=' + button_id;
                                window.location = url;
                            } else {
                                if (message_with_record) {
                                    bootbox.confirm({
                                        message: "No results found",
                                        buttons: {
                                            confirm: {
                                                label: 'Add Record',
                                                className: 'btn-primary'
                                            },
                                            cancel: {
                                                label: 'Cancel',
                                                className: 'btn-danger'
                                            }
                                        },
                                        callback: function (result) {
                                            if (result) {
                                                $section.find('.quick-add').trigger('click').trigger('click');
                                                setTimeout(function (e) {
                                                    let $record = $section.find(`.mobile-rows`).last(),
                                                        url = $record.parents('a').attr('href');
                                                    url = url + '&barcode_btn=' + button_id;
                                                    window.location = url;
                                                }, 500);
                                            }
                                        }
                                    });
                                } else {
                                    bootbox.alert({
                                        message: 'No results found',
                                        callback: function () {
                                        }
                                    })
                                }
                            }
                        }
                    })
                    Scanner.stop().then((ignore) => {
                        $('#html5-qrcode-file-input').remove();
                    }).catch((err) => {
                        // Stop failed, handle it.
                    });
                })
                .then(() => {
                    $('#qr-code-spinner').addClass('d-none');
                })
                .catch(function (err) {
                    $('#qr-window').modal('hide');
                });
        }, 500);
    });

    $('#destroy-barcode').on('click', function (e) {
        Scanner.stop().then((ignore) => {
            $('#html5-qrcode-file-input').remove();
            $('.active-barcode').removeClass('active-barcode');
            $('#qr-window').modal('hide');
            $('#qr-code-spinner').removeClass('d-none');
        }).catch((err) => {
            // Stop failed, handle it.
        });
    });
});